import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as Sentry from '@sentry/vue'; // Only this import is needed in newer versions

import "./index.css";

import I18n from "@/lang/index";

const app = createApp(App).use(store).use(router).use(I18n)

// Initialize Sentry
Sentry.init({
  app,
  dsn: "https://9ddbc70905cf02b06967902b9c5f53c1@o4508914218106880.ingest.us.sentry.io/4508914219679744",
  tracesSampleRate: 1.0, // Adjust based on your needs
  
  // Custom event handling
  beforeSend(event) {
    // Add referrer to each event
    event.tags = event.tags || {};
    event.tags.referrer = document.referrer;
    return event;
  }
});

// First wait for router to be ready
router.isReady().then(() => {
    document.dispatchEvent(new Event('render-event'))
    
    // Mount the app
    app.mount("#app");
    
    // After mounting, asynchronously track the page visit
    setTimeout(() => {
      Sentry.captureMessage('visit', {
        level: 'info',
        tags: { 
          referrer: document.referrer,
          page: window.location.pathname,
          url: window.location.href
        }
      });
    }, 0);
})